// import { useAuth } from './helpers/authContext'; 
// const {rpc_node} = useAuth() 

const config = {
  steemConfig: process.env.RPC_NODE,
  steemEngineRpcConfig: 'https://api.steemit.com',
  steemEngineAccountsConfig: 'alejos7ven',
  hdfAccount: "steem.dao",
  returnProposalAccount: "steem.dao",
  returnProposalId: 0
};

export default config;

// config.ts

let steemConfig = process.env.RPC_NODE || 'https://api.steemit.com';

export const getSteemConfig = () => steemConfig;
export const setSteemConfig = (url: string) => {
  steemConfig = url;
}; 
export const steemEngineRpcConfig = 'https://api.steemit.com';
export const steemEngineAccountsConfig = 'alejos7ven';
export const hdfAccount = "steem.dao";
export const returnProposalAccount = "steem.dao";
export const returnProposalId = 0;
